module.exports = __webpack_public_path__ + "static/img/GettyImages-595172997.980dc39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-595172997.jpg
// module id = 5ic7
// module chunks = 0